interface FontWeight {
  [index: string]: number;
}

interface FontProperties {
  [index: string]: string;
}

const fontWeights: FontWeight = {
  XXXXL: 700,
  XXXL: 700,
  XXL: 700,
  XL: 700,
  L: 600,
  M: 400,
  MContrast: 500,
  S: 400,
  SContrast: 500,
  XS: 400,
  XSContrast: 500,
  XXS: 400,
  XXSContrast: 500,
};

const fontSizes: FontProperties = {
  XXXXL: '3.75rem', // 60px
  XXXL: '3rem', // 48px
  XXL: '2.125rem', // 34px
  XL: '1.5rem', // 24px
  L: '1.25rem', // 20px
  M: '1rem', // 16px
  MContrast: '1rem', // 16px
  S: '0.875rem', // 14px
  SContrast: '0.875rem', // 14px
  XS: '0.75rem', // 12px
  XSContrast: '0.75rem', // 12px
  XXS: '0.625rem', // 10px
  XXSContrast: '0.625rem', // 10px
};

const lineHeights: FontProperties = {
  XXXXL: '4.5rem',
  XXXL: '3.6rem',
  XXL: '2.55rem',
  XL: '1.8rem',
  L: '1.5rem',
  M: '1.25rem',
  MContrast: '1.25rem',
  S: '1.25rem',
  SContrast: '1.25rem',
  XS: '0.9rem',
  XSContrast: '0.9rem',
  XXS: '0.75rem',
  XXSContrast: '0.75rem',
};

const letterSpacings: FontProperties = {
  XXXXL: '-1%',
  XXXL: '-1%',
  XXL: '-1%',
  XL: '-3%',
  L: '-3%',
  M: '-1%',
  MContrast: '-1%',
  S: '-1%',
  SContrast: '-1%',
  XS: '-1%',
  XSContrast: '-1%',
  XXS: '-1%',
  XXSContrast: '-1%',
};

type FontObject = {
  weight: number;
  size: string;
  lineHeight: string;
  letterSpacing: string;
};

export const storybookFonts = (type: string): FontObject => ({
  weight: fontWeights[type],
  size: fontSizes[type],
  lineHeight: lineHeights[type],
  letterSpacing: letterSpacings[type],
});

const font = (type: string): string => {
  return `
    font-weight: ${fontWeights[type]};
    font-size: ${fontSizes[type]};
    line-height: ${lineHeights[type]};
    letter-spacing: ${letterSpacings[type]};
  `;
};

export const font4XL = font('XXXXL');
export const font3XL = font('XXXL');
export const font2XL = font('XXL');
export const fontXL = font('XL');
export const fontL = font('L');
export const fontM = font('M');
export const fontMContrast = font('MContrast');
export const fontS = font('S');
export const fontSContrast = font('SContrast');
export const fontXS = font('XS');
export const fontXSContrast = font('XSContrast');
export const fontXXS = font('XXS');
export const fontXXSContrast = font('XXSContrast');
